import React from "react";
import { FileViewer } from "../viewer/file-viewer.js";
const File = ({ settings = {}, componentData, node }) => {
  return /* @__PURE__ */ React.createElement(
    FileViewer,
    {
      nodeId: node.attrs.id,
      componentData,
      settings,
      isLoading: node.attrs.loading,
      tempDataPlaceHolder: node.attrs.tempData
    }
  );
};
export {
  File
};
//# sourceMappingURL=component.js.map
